import { Injectable, inject } from '@angular/core';
import { BooklistAggrigatorModel } from '@app/pages/booklists/models/booklist-aggrigator-model';
import { IClubWithActiveCourseModel } from '@app/pages/clubs/models/club-with-active-course-model';
import { IPostModel } from '@app/pages/posts/models/post.model';
import { QuoteModel } from '@app/pages/quotes/models/quote-model';
import { LocalRepository } from '@shared/helper/local-repository';
import { ActivitiesAggrigatorModel, CarriedModel } from '@shared/model/activities-aggrigator-model';
import { ActivityPluseAggrigatorModel } from '@shared/model/activity-plus-aggrigator-model';
import { ActivityVerbEnum } from '@shared/model/enum/activity-verb-enum';
import { ObjectTypeEnum } from '@shared/model/enum/object-type-enum';
import { ReviewAggrigatorModel } from '@shared/model/review-aggrigator-model';
@Injectable({
  providedIn: 'root'
})
export class FeedsUtilityService {
  repo = inject(LocalRepository);


  setUsersVisibility() {
    if (this.repo.IsInBrowser) {
      if (this.repo.IsInMobile) {
        return this.repo.getLocalItem('hiddenUsernavbar') ? false : true;
      }
      return true;
    }
    else return false;
  }

  // ! don't know the condition
  checkAndfilterActivities(activities: ActivityPluseAggrigatorModel[]) {
    return activities?.filter(a => a?.mainFeed.verb !== ActivityVerbEnum.Chanllenged &&
      a.mainFeed.verb !== ActivityVerbEnum.Joined &&
      a.mainFeed?.inDirectObject?.data &&
      a.mainFeed?.inDirectObject.objectType !== ObjectTypeEnum.Challenge);
  }

  AdaptBookListToFeedModel(suggestedBookLists: BooklistAggrigatorModel[]) {
    return suggestedBookLists?.map(booklist => {
      const newFeedItem: ActivityPluseAggrigatorModel = new ActivityPluseAggrigatorModel();
      newFeedItem.mainFeed = booklist;
      newFeedItem.mainFeed.totalComments = booklist.totalComments;
      newFeedItem.mainFeed.totalLikes = booklist.totalLikes;
      newFeedItem.mainFeed.verb = ActivityVerbEnum.Booklisted;
      newFeedItem.mainFeed.inDirectObject = new BooklistAggrigatorModel();
      newFeedItem.mainFeed.inDirectObject.data = {
        books: booklist.books,
        description: booklist.description,
        title: booklist.title,
        count: booklist.count,
        id: booklist.id,
      };
      newFeedItem.mainFeed.inDirectObject.objectType = ObjectTypeEnum.Booklist;
      newFeedItem.mainFeed.inDirectObject.objectId = booklist.id;
      newFeedItem.mainFeed.affectedUser = {};
      newFeedItem.mainFeed.isSuggest = true;
      newFeedItem.otherFeeds = [];
      return newFeedItem;
    });
  }


  AdaptQuotesToFeedModel(suggestedQuotes: QuoteModel[]) {
    return suggestedQuotes?.map(quote => {
      const newFeedItem: ActivityPluseAggrigatorModel = new ActivityPluseAggrigatorModel();
      newFeedItem.mainFeed = new ActivitiesAggrigatorModel();
      newFeedItem.mainFeed = quote;
      newFeedItem.mainFeed.totalComments = quote.totalComments;
      newFeedItem.mainFeed.totalLikes = quote.totalLikes;
      newFeedItem.mainFeed.verb = ActivityVerbEnum.Quoted;
      newFeedItem.mainFeed.carried = new CarriedModel();
      newFeedItem.mainFeed.inDirectObject = new QuoteModel();
      newFeedItem.mainFeed.inDirectObject.data = {
        pageNum: quote?.pageNum,
        id: quote?.id,
        hasPhoto: quote?.hasPhoto,
        mediaId: quote?.mediaId,
        mediaRatio: quote?.mediaRatio,
        mediaExtension: quote?.mediaExtension,
        body: quote.body
      };
      newFeedItem.mainFeed.object = {};
      newFeedItem.mainFeed.object.data = quote;
      newFeedItem.mainFeed.inDirectObject.objectType = ObjectTypeEnum.Quote;
      newFeedItem.mainFeed.inDirectObject.objectId = quote?.id;
      newFeedItem.mainFeed.affectedUser = {};
      newFeedItem.mainFeed.isSuggest = true;
      newFeedItem.otherFeeds = [];
      return newFeedItem;
    });
  }

  AdaptReviewsToFeedModel(suggestedReviews: ReviewAggrigatorModel[]) {
    return suggestedReviews?.map(review => {
      const newFeedItem: ActivityPluseAggrigatorModel = new ActivityPluseAggrigatorModel();
      newFeedItem.mainFeed = review;
      newFeedItem.mainFeed.totalComments = review?.totalComments;
      newFeedItem.mainFeed.totalLikes = review?.totalLikes;
      newFeedItem.mainFeed.verb = ActivityVerbEnum.Reviewed;
      newFeedItem.mainFeed.inDirectObject = review?.review;
      newFeedItem.mainFeed.affectedUser = {};
      newFeedItem.mainFeed.isSuggest = true;
      newFeedItem.mainFeed.isSuggest = true;
      newFeedItem.otherFeeds = [];
      return newFeedItem;
    });
  }


  AdaptPostsToFeedModel(suggestedPosts: IPostModel[]) {
    return suggestedPosts?.map(post => {
      const newFeedItem: ActivityPluseAggrigatorModel = new ActivityPluseAggrigatorModel();
      newFeedItem.mainFeed = post;
      newFeedItem.mainFeed.verb = ActivityVerbEnum.Posted;
      newFeedItem.mainFeed.totalComments = post.totalComments;
      newFeedItem.mainFeed.totalLikes = post.totalLikes;
      newFeedItem.mainFeed.inDirectObject = {};
      newFeedItem.mainFeed.inDirectObject.data = {
        title: post?.title,
        tools: post?.tools,
        preview: post?.preview,
        readingTime: post?.readingTime,
        userLiked: post?.userLiked,
        hasPhoto: post?.hasPhoto,
        mediaId: post?.mediaId,
        mediaRatio: post?.mediaRatio,
        mediaExtension: post?.mediaExtension,
      };
      newFeedItem.mainFeed.inDirectObject.objectType = ObjectTypeEnum.Post;
      newFeedItem.mainFeed.inDirectObject.objectId = post.id;
      newFeedItem.mainFeed.affectedUser = {};
      newFeedItem.mainFeed.isSuggest = true;
      newFeedItem.otherFeeds = [];
      return newFeedItem;
    });
  }

  AdaptClubsToFeedModel(suggestedClubs: IClubWithActiveCourseModel[]) {
    return suggestedClubs?.map(club => {
      const newFeedItem: ActivityPluseAggrigatorModel = new ActivityPluseAggrigatorModel();
      newFeedItem.mainFeed = {
        suggestedClub: club,
        verb: ActivityVerbEnum.suggestedClub,
        isSuggest: true,
      };
      newFeedItem.otherFeeds = [];
      return newFeedItem;
    });
  }

  randomizeSuggestions(suggestions: ActivityPluseAggrigatorModel[]) {
    for (let i = suggestions?.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [suggestions[i], suggestions[j]] = [suggestions[j], suggestions[i]];
    }
    return suggestions;
  }

}
